import { render, staticRenderFns } from "./OtherFiles.vue?vue&type=template&id=51d99cb2"
import script from "./OtherFiles.vue?vue&type=script&lang=js"
export * from "./OtherFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports